import styles from './Salary.less';

import React, { Component, PropTypes } from 'react';

import RefineRadio from 'RefineRadio/RefineRadio';
import SalaryType from 'SalaryType/SalaryType';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import { preventRenderingInClientIfNot } from 'prevent-rendering-if-not';
import {
  optimisticUpdateSalaryMaxClicked,
  optimisticUpdateSalaryMinClicked
} from 'store/search/optimistic/refinement';

function getOptimisticUpdateHandler(label) {
  return label === 'Maximum' ?
    optimisticUpdateSalaryMaxClicked :
    optimisticUpdateSalaryMinClicked;
}

export default class Salary extends Component {

  static propTypes = {
    handleSelection: PropTypes.func.isRequired,
    salaries: PropTypes.array.isRequired,
    salaryTypes: PropTypes.array.isRequired,
    active: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired
  };

  shouldComponentUpdate({ active }) {
    return active;
  }

  render() {
    const { handleSelection, salaries, salaryTypes, label, active } = this.props;
    const id = `refineSalary${label}`;

    return (
      <nav role="navigation" className={styles.root}>
        <ScreenReaderOnly>
          <h1 id={id}>{`${label} salary`}</h1>
        </ScreenReaderOnly>
        { preventRenderingInClientIfNot(active) ?
          <RefineRadio
            handleSelection={handleSelection}
            preNavigationAction={getOptimisticUpdateHandler(label)}
            labelledBy={id}
            options={salaries}
            path="/jobs"
            data-automation={id}
          /> : null }
        <SalaryType
          data-automation={`${id}SalaryType`}
          salaryTypes={salaryTypes}
          className={styles.types}
        />
      </nav>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Search/components/RefineBar/components/Salary/Salary.js
 **/